/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class InvitePeoplePopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(invitePeopleComponent) {
    invitePeopleComponent.setAttribute('main-content', 'invite-people');
  }
}
